import React from 'react';
import { login } from '../../../services/auth';
import { Input, PasswordInput } from '../../../components/Form';
import { Text } from 'rebass';
import Button from '../../../components/Button/Button';
import { useHistory } from 'react-router-dom';
import AuthForm from '../components/AuthForm';

/**
 * @component for login form
 */
const LoginForm: React.FC = () => {
  const [email, setEmail] = React.useState('');
  const [pw, setPW] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const history = useHistory();

  // Handles when form is submitted
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await login(email, pw);
    } catch (err) {
      setErrorMessage((err as Error).message);
    }
  };

  // When input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessage('');
    e.target.name === 'email'
      ? setEmail(e.target.value)
      : setPW(e.target.value);
  };

  const handleForgotPasswordClick = () => {
    history.push(
      '/forgot-password' + (email ? `?email=${encodeURIComponent(email)}` : '')
    );
  };

  return (
    <AuthForm onSubmit={handleSubmit}>
      <Input
        id="input-email"
        type="email"
        placeholder="Email"
        mt={5}
        padding={5}
        name="email"
        value={email}
        onChange={handleInputChange}
      />
      <PasswordInput
        id="input-password"
        name="password"
        placeholder="Password"
        mt={3}
        padding={5}
        value={pw}
        onChange={handleInputChange}
        showPassword={showPassword}
        toggleShowPassword={() => setShowPassword(!showPassword)}
      />

      {errorMessage && (
        <Text variant="subheading" mt={2} sx={{ color: '#D9534F' }}>
          {errorMessage}
        </Text>
      )}
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Button mt={errorMessage ? 2 : 6} type="submit" variant="primary">
          Login
        </Button>
        <Button mt={6} variant="outline" onClick={handleForgotPasswordClick}>
          Forgot Password?
        </Button>
      </div>
    </AuthForm>
  );
};

export default LoginForm;
